import LoginModalContent from './LoginModalContent';

export default LoginModalContent;